<template>
  <div>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fas fa-envelope"></i>
          Emails bienvenida
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="float-right mr-3" right variant="success" @click="testEmail">Test
        </b-button>
        <b-button class="float-right mr-3" right variant="success" @click="updateWelcome">{{
          $t("public.components.organization.preferences.btnModify")
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <div class="glosario">
          <p><strong>{fullname}</strong> - Se reemplaza con el nombre completo del paciente.</p>
          <p><strong>{phone}</strong> - Se reemplaza con el número de teléfono del paciente.</p>
          <p><strong>{address}</strong> - Se reemplaza con la dirección del paciente.</p>
          <p><strong>{galatea_code}</strong> - Se reemplaza con el código único de Galatea para el paciente.</p>
          <p><strong>{galatea_professional_name}</strong> - Se reemplaza con el nombre professional asignado al paciente de Galatea.</p>
          <p><strong>{galatea_professional_address}</strong> - Se reemplaza con el dirección professional asignado al paciente de Galatea.</p>
          <p><strong>{galatea_professional_phone}</strong> - Se reemplaza con el teléfono professional asignado al paciente de Galatea.</p>
          <p><strong>{galatea_core_link}</strong> - Se reemplaza con el enlace al core de Galatea específico del
            paciente.</p>
        </div>
        <div v-if="patientWelcomes.patientWelcomeLanguages">
          <b-content v-for="(patientWelcome, index) in patientWelcomes.patientWelcomeLanguages" :key="index">
            <br>
            <b-row>{{ patientWelcome.content.key }} - {{ patientWelcome.content.locale }}</b-row>
            <b-row>
              <b-form-group label-for="tradename">
                <template slot="label">Asunto:
                </template>
                <b-form-input id="tradename" v-model="patientWelcome.title.content" type="text"></b-form-input>
              </b-form-group></b-row>
            <b-row>
              <ckeditor id="newHelpGlobal.content" v-model="patientWelcome.content.content" :config="configCK" type="classic"></ckeditor>
            </b-row>
          </b-content>
        </div>
      </template>
    </iq-card>
  </div>
</template>
<script>
import { xray } from "../../config/pluginInit";

import patientWelcomeService from "../../services/patientWelcome";

export default {
  name: "PreferencesEmail",
  props: {
  },
  mounted() {
    xray.index();
    this.getAllWelcome();
  },
  methods: {
    getAllWelcome() {
      let self = this;

      this.$awn.asyncBlock(
        patientWelcomeService.getAll(),
        (response) => {
          if (response && response.data && response.data.id !== null) {
            self.patientWelcomes = response.data;
          } else {
            self.patientWelcomes = {
              id: null,
              patientWelcomeLanguages: [
                { id: null, title: { locale: "en", key: "emailWelcome", content: "Welcome to our email service in English!" }, content: { locale: "en", key: "emailContent", content: "This is the content of the email in English." } },
                { id: null, title: { locale: "es", key: "emailWelcome", content: "¡Bienvenido a nuestro servicio de correo electrónico en español!" }, content: { locale: "es", key: "emailContent", content: "Este es el contenido del correo electrónico en español." } },
                { id: null, title: { locale: "cat", key: "emailWelcome", content: "Benvinguts al nostre servei de correu electrònic en català!" }, content: { locale: "cat", key: "emailContent", content: "Aquest és el contingut del correu electrònic en català." } }
              ]
            };
          }
        },
        (error) => {
          console.log(error);
        },
        " "
      );
    },
    updateWelcome() {
      let self = this;

      this.$awn.asyncBlock(
        patientWelcomeService.update(self.patientWelcomes),
        (response) => {
          if (response) {
            self.patientWelcomes = response.data;
          }
        },
        (error) => {
          log.error(error);
        },
        " "
      );
    },
    testEmail() {
      let self = this;

      this.$awn.asyncBlock(
        patientWelcomeService.testEmail(),
        (response) => {
          if (response) {

          }
        },
        (error) => {
          log.error(error);
        },
        " "
      );
    },

  },
  computed: {},
  data() {
    return {
      patientWelcomes: [],
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
        mediaEmbed: {
          previewsInData: true
        }
      },
    };
  },
  components: {},
};
</script>